<template>
    <Modal :show-footer="false" ref="modal">
        <template v-slot:header>
            {{ lang?.modal?.title }}
        </template>

        <template v-slot:body>
            <VoucherText :lang="lang.VoucherText" @save="save()" v-model="cart.item.value"></VoucherText>
        </template>
    </Modal>
</template>

<script>
import axios from "axios";
import Modal from '@/scripts/woocommerce/components/modal.vue';
import VoucherText from '@/scripts/woocommerce/components/voucher-text.vue';

export default {
    components: {
        Modal,
        VoucherText,
    },

    data() {
        return {
            lang: window.localization?.cart?.voucher,

            loading: false,

            cart: {
                item: {
                    key: null,
                    value: null,
                }
            }
        }
    },

    methods: {
        save() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            const data = new FormData();
            data.append('action', 'at_cart_voucher_edit');
            data.append('key', this.cart.item.key);
            data.append('value', this.cart.item.value);

            axios({
                method: 'POST',
                url: window.wordpress.ajax_url,
                data,
            }).then(response => {
                location.reload();
            }).catch(error => {
                alert('Something went wrong');
                location.reload();
            });
        },
    },

    created() {
        // Add event listener to cart item 'edit' link
        document.addEventListener('click', e => {
            if (e.target && e.target.classList.contains('js-voucher-edit')) {
                this.cart.item.key   = e.target.getAttribute('data-key');
                this.cart.item.value = JSON.parse(e.target.getAttribute('data-value'));
                this.$refs.modal.open();
            }
        });
    }
}
</script>
